import type { Dispatch, SetStateAction } from "react";

export function showError(
  error: string,
  setError: Dispatch<SetStateAction<string>>,
  form: HTMLFormElement,
  ...fields: HTMLInputElement[]
) {
  setFieldValidities(error, setError, form, fields);
  form.classList.add("was-validated");
}

export function clearError(
  setError: Dispatch<SetStateAction<string>>,
  form: HTMLFormElement,
  ...fields: HTMLInputElement[]
) {
  setFieldValidities("", setError, form, fields);
  form.classList.remove("was-validated");
}

function setFieldValidities(
  error: string,
  setError: Dispatch<SetStateAction<string>>,
  form: HTMLFormElement,
  fields: HTMLInputElement[],
) {
  setError(error);
  const inputElements = fields.length > 0 ? fields : getInputElements(form);
  for (const field of inputElements) {
    field.setCustomValidity(error);
  }
}

function getInputElements(form: HTMLFormElement) {
  return Array.from(form.elements)
    .filter((element): element is HTMLInputElement => element instanceof HTMLInputElement);
}
